
export default [
    {
        path: '/admin/deduction-items',
        name: 'deduction-items',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/item-deduction/index.vue')
    }
]